import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { ROUTES } from '@repo/common';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSText } from '@repo/sds/SDSText';
import { SettingsPanel } from '@repo/ui/components/elements/SettingsPanel/SettingsPanel';
import { SettingsMobileMenu } from '@repo/ui/components/elements/settings-mobile-menu/settings-mobile-menu';
import { settingSidebarItems } from '@repo/ui/constants/settings';
import { useDeviceType } from '@repo/ui/hooks/use-device-type';
import { useFeatureFlag } from '@repo/ui/hooks/use-feature-flag';

import './settings-layout.scss';

export function SettingsLayout() {
  const { t } = useTranslation('common');
  const { isMobileOrTablet } = useDeviceType();
  const isAvailabilityEnabled = useFeatureFlag('settings_availability');
  const isPaymentsEnabled = useFeatureFlag('settings_payments');
  const isNotificationsEnabled = useFeatureFlag('settings_notifications');
  const isIntegrationsEnabled = useFeatureFlag('settings_integrations');
  const isMbaEnabled = useFeatureFlag('mba_certificate');

  const filteredItems = settingSidebarItems.filter(item => {
    switch (item.path) {
      case ROUTES.AVAILABILITY:
        return isAvailabilityEnabled;
      case ROUTES.BILLING:
        return isPaymentsEnabled;
      case ROUTES.NOTIFICATIONS:
        return isNotificationsEnabled;
      case ROUTES.INTEGRATIONS:
        return isIntegrationsEnabled;
      case ROUTES.MY_MBA:
        return isMbaEnabled;
      default:
        return true;
    }
  });

  return (
    <SDSFlexbox className="SettingsLayout" direction="column" fullWidth gap="card-large">
      <SDSText text={t('security.accountTitle')} type="h4" />
      <SDSFlexbox
        alignItems="stretch"
        className="SettingsLayout__body"
        direction={isMobileOrTablet ? 'column' : 'row'}
        fullWidth
        gap="card-large"
      >
        {isMobileOrTablet ? (
          <SettingsMobileMenu items={filteredItems} allItems={settingSidebarItems} />
        ) : (
          <SettingsPanel items={filteredItems} />
        )}
        <SDSFlexbox className="SettingsLayout__content" direction="column" fullWidth>
          <Outlet />
        </SDSFlexbox>
      </SDSFlexbox>
    </SDSFlexbox>
  );
}
